import AcademyDashboard from './AcademyDashboard.component';

export default AcademyDashboard;
